import { Box, Stack, Typography, ListItemButton } from 'components/ui';
import { CircleIcon } from 'components/uiIcons';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';
import { notificationIcon, notificationColor, notificationRoute } from 'utils/notification';
import MarkAsReadMutation from 'mutations/notification/mark_as_read';
import UnreadNotificationsCountQuery from 'queries/notification/unread_count';
import RelativeTime from 'components/relative_time';
import theme from 'theme';

const NotificationItem = ({ notification, onClick, compact = false }) => {
  const navigate = useNavigate();
  const isUnread = !notification.readAt;

  const [markAsRead] = useMutation(MarkAsReadMutation, {
    variables: { id: notification.id },
    optimisticResponse: {
      markNotificationAsRead: {
        __typename: 'MarkNotificationAsReadPayload',
        notification: {
          __typename: 'NotificationType',
          id: notification.id,
          readAt: new Date().toISOString(),
        },
      },
    },
    refetchQueries: [{ query: UnreadNotificationsCountQuery }],
  });

  const Icon = notificationIcon(notification.kind);
  const color = notificationColor(notification.kind);

  const handleClick = () => {
    if (isUnread) {
      markAsRead();
    }
    const route = notificationRoute(notification);
    if (route) {
      navigate(route);
    }
    onClick?.();
  };

  return (
    <ListItemButton
      onClick={handleClick}
      sx={{
        alignItems: 'flex-start',
        gap: 1.5,
        py: compact ? 1 : 1.5,
        backgroundColor: isUnread ? theme.palette.notification.unreadBackground : 'transparent',
      }}
    >
      <Box sx={{ color, mt: 0.5, display: 'flex' }}>
        <Icon fontSize="small" />
      </Box>
      <Stack sx={{ flexGrow: 1, minWidth: 0 }} spacing={0.25}>
        <Typography variant="body2" sx={{ fontWeight: isUnread ? 700 : 500 }} noWrap={compact}>
          {notification.title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap={compact}>
          {notification.body}
        </Typography>
        <RelativeTime date={notification.createdAt} />
      </Stack>
      {isUnread && (
        <CircleIcon sx={{ fontSize: 10, color: theme.palette.notification.unreadDot, mt: 1 }} />
      )}
    </ListItemButton>
  );
};

export default NotificationItem;
